import { mapState, mapGetters, mapMutations } from 'vuex';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
export default {
  name: 'domstyle',
  components: {},
  meta: {
    title: ''
  },
  props: {
    value: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      minWidth: 0,
      minHeight: 0,
      form: {}
    };
  },
  created() {},
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.styleHandle(val);
        }
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    styleHandle(val) {
      let data = {
        ...val
      };
      this.form.width = data.width;
      this.form.height = data.height;
      this.form.x = data.x;
      this.form.y = data.y;
    },
    inputChange(val, type) {
      // let obj = {}
      // obj[type] = val
      this.$emit('domstyle', this.form);
    }
  }
};